import React, { useCallback, useState } from 'react';
import { Container, Box, Snackbar, Typography, Button } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { getProductFinderStructure, getProductsStructure } from '../csvImport';
import {
  updateProductFinder,
  updateProducts,
} from '../firebaseConnection/database';
import Dropzone from '../hooks/Dropzone';

const ImportPage = observer((): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      try {
        const firebaseData = await getProductsStructure(acceptedFiles[0]);
        delete firebaseData.undefined;
        await updateProducts(firebaseData);
        setMessage('Success!');
        setOpen(true);
      } catch (e) {
        setMessage(`Error: ${e}`);
        setOpen(true);
      }
      setOpen(true);
    }
  }, []);

  const fileData = useLocalObservable(() => ({
    configFile: new File([], ''),
    dataFile: new File([], ''),
  }));

  const addConfigFile = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      const [inputFile] = Array.from(acceptedFiles);
      fileData.configFile = inputFile;
    }
  }, []);

  const addDatafile = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      const [inputFile] = Array.from(acceptedFiles);
      fileData.dataFile = inputFile;
    }
  }, []);

  const uploadProductfinderData = async () => {
    try {
      if (fileData.configFile.size > 0 && fileData.dataFile.size > 0) {
        const finderData = await getProductFinderStructure(
          fileData.configFile,
          fileData.dataFile,
        );

        await updateProductFinder(finderData);
        setMessage('Success');
        setOpen(true);
      } else {
        setMessage('Configfile or Datafile missing');
      }
    } catch (e) {
      setMessage(`Error: ${e}`);
      setOpen(true);
      console.log(e);
    }
  };

  return (
    <>
      <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Typography variant="h4">Produkte</Typography>
          <Dropzone drop={csvFile => onDrop(csvFile)} />
        </Box>

        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Typography variant="h4">Produktfinder</Typography>
          <Typography variant="subtitle2">Config File</Typography>
          <Dropzone drop={csvFile => addConfigFile(csvFile)} />
          <Typography variant="subtitle2">Data File</Typography>

          <Dropzone drop={csvFile => addDatafile(csvFile)} />

          <Typography>Config File: {fileData.configFile.name} </Typography>
          <Typography>Data File: {fileData.dataFile.name} </Typography>
          <Button onClick={uploadProductfinderData}>Upload Finder </Button>
        </Box>

        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message={message}
        />
      </Container>
    </>
  );
});

export default ImportPage;
